import { useCssHandles } from '../../../../utils/functions';
import ArrowIcon from './ArrowIcon';

const CSS_HANDLES = [
	'filter__container',
	'filter',
	'filterAvailable',
	'filterIsOpen',
	'filterTitle',
	'filterTitleSpan',
	'filterIcon',
	'filterTemplateOverflow',
	'filterContent',
	'filterItem',
	'filterItem',
	'filterItem',
	'selectedFilterItem',
	'line-container',
	'container',
	'inner-container',
	'box-wrapper',
	'box',
	'input',
	'label',
];

const FilterContentCor = ({ filter }: any) => {
	const { handles, withModifiers }: any = useCssHandles('vtex-search-result-3-x', CSS_HANDLES);
	const filterContainerCor = withModifiers('filter__container', 'cor');
	const filterItemSelected = withModifiers('selectedFilterItem', 'selected');

	return (
		<div className={`${filterContainerCor} bb b--muted-4`}>
			<div className={`${handles.filter} pv5 ${handles.filterAvailable} ${handles.filterIsOpen}`}>
				<div role="button" className={`pointer" aria-disabled="false`}>
					<div className={`${handles.filterTitle} f5 flex items-center justify-between`}>
						<span className={`${handles.filterTitleSpan}`}>{filter.title}</span>
						<span className={`vtex-search-result-3-x-filterIcon flex items-center ph5 c-muted-3`}>
							<ArrowIcon />
						</span>
					</div>
				</div>
			</div>

			<div
				className={`${handles.filterTemplateOverflow} pb5 overflow-y-auto`}
				data-testid="scrollable-element"
				aria-hidden="false"
				style={{ maxHeight: '200px' }}
			>
				<div style={{ height: 'auto' }}>
					<div className={`${handles.filterContent}`}>
						{/* Inicio preto */}
						{filter.items.map((item: any, index: number) => (
							<div
								className={`${index == 0 && filterItemSelected} ${withModifiers('filterItem', item)}  lh-copy w-100`}
								title="Branco"
								style={{ hyphens: 'auto', wordBreak: 'break-word' }}
							>
								<div
									className={`vtex-checkbox__line-container flex items-start relative pointer`}
									style={{ width: 'max-content' }}
								>
									<div className={`vtex-checkbox__container relative w1 h1 mr3`}>
										<div
											className={`vtex-checkbox__inner-container h1 w1 absolute ba bw1 br1  ${index == 0 ? 'b--action-primary bg-action-primary' : 'b--muted-4'}  mr3`}
										></div>
										<div className={`vtex-checkbox__box-wrapper absolute w1 h1 flex o-100`} style={{ left: '0px' }}>
											<div
												className={`vtex-checkbox__box absolute top-0 left-0 bottom-0 overflow-hidden w-100 flex items-center align-center justify-center c-on-action-primary`}
											>
												{index == 0 && (
													<svg
														className="vtex__icon-check"
														width="12"
														height="12"
														viewBox="0 0 12 12"
														xmlns="http://www.w3.org/2000/svg"
														fill="none"
													>
														<path d="M10.8 4.4L9.4 3L5.4 7L3.4 5L2 6.4L5.4 9.8L10.8 4.4Z" fill="currentColor"></path>
													</svg>
												)}
											</div>
										</div>
										<input
											className={`vtex-checkbox__input h1 w1 absolute o-0 pointer`}
											id="brand-sony"
											type="checkbox"
											tabIndex={0}
											value="Sony"
											checked
										/>
									</div>

									<label className="vtex-checkbox__label w-100 c-on-base pointer" htmlFor="cor-branco">
										{item}
									</label>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default FilterContentCor;
